import React, { useState } from 'react';
import './FilterList.css';

function FilterList({ filters, onFilterClick }) {
    const [ filterUsed, setFilterUsed ] = useState(filters[0]);
    const selectFilter = (filter) => {
        setFilterUsed(filter);
    }

    const handleClick = ({ target }) => {
        onFilterClick(target.textContent);
        selectFilter(target.textContent);
    }

    return(
        <div className="filter-container">
            {filters.map((filter, index) => {
                if (filter == filterUsed) {
                    return (<div onClick={handleClick} className="filter selected" key={index.toString()}>
                        {filter}
                    </div>)
                }
                return (
                <div onClick={handleClick} className="filter" key={index.toString()}>
                    {filter}
                </div>)
            })}
        </div>
    )
}

export default FilterList;